


    
    export class GPhoneCommandBodyDTO {
        
        
        action: string;
    }
